import CrudCustom from '../../../libs/custom/CrudCustom';

let EntitasPajakService = new CrudCustom('/entitas-pajaks');
export default EntitasPajakService;
